import { MapPin, Navigation, ShieldCheck } from "lucide-react";
import { ADDRESS, ARRIVAL_NOTE, BRAND } from "@/config/site";
import { cn } from "@/lib/utils";

// Reusable location card with Google Maps directions + security note.
export const LocationCard = ({ tone = "dark", showMap = true, className = "" }) => {
  const isLight = tone === "light";
  return (
    <div
      className={cn(
        "overflow-hidden rounded-3xl border",
        isLight
          ? "border-legacy-charcoal/10 bg-white"
          : "border-white/10 bg-white/[0.03]",
        className
      )}
      data-testid="location-card"
    >
      <div className="grid md:grid-cols-2">
        <div className="p-8 md:p-10">
          <div className="flex items-center gap-2 text-legacy-mint">
            <MapPin className="h-5 w-5" aria-hidden="true" />
            <span className={cn("text-xs uppercase tracking-[0.2em] font-medium", isLight ? "text-legacy-gold" : "text-legacy-mint")}>
              Visit Us
            </span>
          </div>
          <address
            className={cn(
              "not-italic mt-5 font-heading text-2xl md:text-3xl leading-snug",
              isLight ? "text-legacy-charcoal" : "text-white"
            )}
          >
            {BRAND.legalName}
            <br />
            {ADDRESS.line1}
            <br />
            {ADDRESS.line2}
            <br />
            {ADDRESS.city}, {ADDRESS.state} {ADDRESS.zip}
          </address>

          <a
            href={ADDRESS.mapsDirections}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-legacy-mint px-6 py-3 text-sm font-semibold text-legacy-charcoal transition-all hover:bg-legacy-mint/90"
            data-testid="maps-directions-btn"
            aria-label="Get directions on Google Maps (opens in a new tab)"
          >
            <Navigation className="h-4 w-4" aria-hidden="true" />
            Get Directions
          </a>

          <div
            className={cn(
              "mt-7 flex items-start gap-3 rounded-xl p-4 text-sm",
              isLight ? "bg-legacy-softmint text-legacy-charcoal/80" : "bg-white/5 text-white/70"
            )}
            data-testid="arrival-note"
          >
            <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-legacy-gold" aria-hidden="true" />
            <p>{ARRIVAL_NOTE}</p>
          </div>
        </div>

        {showMap && (
          <div className="min-h-[280px] md:min-h-full">
            <iframe
              title="Legacy Spa location map"
              src={ADDRESS.mapsEmbed}
              className="h-full w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        )}
      </div>
    </div>
  );
};
